import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';

function MenuButton() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };

    const navigateAndClose = (path: string) => {
        setIsOpen(false);
        navigate(path);
    };

    return (
        <>
            <Box
                sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    zIndex: 1300,
                }}
            >
                <IconButton
                    onClick={toggleDrawer}
                    sx={{ color: 'white' }}
                    aria-label="toggle menu"
                    size="large"
                >
                    {isOpen ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
            </Box>

            <Drawer
                anchor="right"
                open={isOpen}
                onClose={toggleDrawer}
                PaperProps={{
                    sx: {
                        width: '100%',
                        height: '100%',
                        bgcolor: 'background.default',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        pt: 4,
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flexGrow: 1,
                        gap: 4,
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h5" fontWeight={600} onClick={() => navigateAndClose('/dizengoff_mommies/about')} sx={{ cursor: 'pointer' }}>
                        About
                    </Typography>
                    <Typography variant="h5" fontWeight={600} onClick={() => navigateAndClose('/dizengoff_mommies')} sx={{ cursor: 'pointer' }}>
                        Upcoming Events
                    </Typography>
                    <Typography variant="h5" fontWeight={600} onClick={() => navigateAndClose('/dizengoff_mommies/gift')} sx={{ cursor: 'pointer' }}>
                        Gift Card
                    </Typography>
                </Box>
            </Drawer>
        </>
    );
}

export default MenuButton;
